import { render, staticRenderFns } from "./Lgx328177784029446144.vue?vue&type=template&id=090b8054&"
import script from "./Lgx328177784029446144.vue?vue&type=script&lang=js&"
export * from "./Lgx328177784029446144.vue?vue&type=script&lang=js&"
import style0 from "./Lgx328177784029446144.vue?vue&type=style&index=0&id=090b8054&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports